import { cn } from "@/lib/utils";

/**
 * Header sağ aksiyonları tek bir "ada": ortak çerçeve, ortak zemin.
 * İç butonlar çerçevesiz — renkli halka / marka rengi toolbar'ı parçalamasın.
 */
export const headerToolbarClass = cn(
  "flex h-9 items-center gap-0.5 rounded-full p-0.5",
  "border border-border-secondary bg-bg-secondary/70",
  "dark:border-white/10 dark:bg-gray-800/70",
);

/**
 * Ada içi buton: çerçevesiz. İkon kendi rengini taşır; hover yalnızca zemin.
 */
export const headerActionClass = cn(
  "relative inline-flex h-8 items-center justify-center rounded-full",
  "border-0 bg-transparent text-text-secondary shadow-none",
  "transition-[background-color] duration-200",
  "hover:bg-black/[0.05]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-module-accent/40",
  "dark:text-gray-300 dark:hover:bg-white/[0.08]",
);
